module.exports = __webpack_public_path__ + "img/arrow-left.97ed6830.svg";